import React from 'react'
import classes from "./box.module.css"
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade'

import zz2 from './../../Assest/m1.png';
import zz12 from './../../Assest/m2.png';
import zz13 from './../../Assest/m3.png';
import zz14 from './../../Assest/m4.png';
import zz15 from './../../Assest/m5.png';

const box = () => {
  return (
    <div className={classes.steps}>

        <h2 className={classes.ih3p}>OUR SERVICES </h2>
        <h4 className={classes.ih3hp}>We offer complete support for the India Medical & Engineering Admission Process</h4>

<br/>

    


<div className={classes.steps1}> 
<Fade left >
<div className={classes.dbn}> <img src={zz2} className={classes.imgs} /><h5 className={classes.ih3}>Detailed Admission Guidence</h5>  <h6 className={classes.ih3h}>Get step-by-step support througt the entire admission process.</h6></div>
</Fade>
<Fade left >
<div className={classes.dbn1}> <img src={zz12} className={classes.imgs} /><h5 className={classes.ih3}>One-on-One Personalized Counseling</h5> <h6 className={classes.ih3h}> Receive Tailored Advice from expert counselors to match your goals.</h6>  </div>
</Fade>
<Fade>
<div className={classes.dbn}> <img src={zz13} className={classes.imgs} /> <h5 className={classes.ih3}>College Budget List and Worksheet</h5> <h6 className={classes.ih3h}> Explore Colleges that lign with your academic aspirations and budget </h6>  </div>
</Fade>
<Fade right >
<div className={classes.dbn1}> <img src={zz14} className={classes.imgs} /> <h5 className={classes.ih3}>College Preference List</h5> <h6 className={classes.ih3h}> Get a customized list of colleges based on your interest and Rank</h6> </div>
</Fade>
<Fade right >
<div className={classes.dbn}> <img src={zz15} className={classes.imgs} /> <h5 className={classes.ih3}>Round Wise College Cut Off Merit List </h5> <h6 className={classes.ih3h}> Stay updated with round wise cut-off details to make informed decisions.</h6> </div>
</Fade>

</div>

<br/> <br/>
<br/>




    </div>
  )
}

export default box


